import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import cn from 'classnames';

import { Icon } from 'legacy-packages/ft-cb';

/**
 * Draws the toggle button
 * */
class Toggle extends PureComponent {
  static displayName = 'Toggle';

  static propTypes = {
    onChange: PropTypes.func,
    onUpdate: PropTypes.func,
  };

  static defaultProps = {
    onChange: () => {},
    onUpdate: () => {},
  };

  static LABELS = {
    expanded: 'Hide Details',
    collapsed: 'Question Details',
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    Toggle.LABELS = {
      expanded: 'Hide Scoring and Details',
      collapsed: 'Question Scoring and Details',
    };

    this.pageWrapper = document.querySelector('.question-preview-player');

    this.toggleButtonRender = this.toggleButtonRender.bind(this);
    this.onToggleClick = this.onToggleClick.bind(this);
    this.onToggleKeyPress = this.onToggleKeyPress.bind(this);
    this.doToggle = this.doToggle.bind(this);
  }

  componentDidMount() {
    this.itemTagsToggle = document.querySelector(
      '.ItemMetadata__toggle_button span',
    );
    if (this.props.expanded && this.pageWrapper) {
      this.pageWrapper.classList.add('has-item-tags');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    /**
     * When updated while opened use callback
     * */
    const { expanded } = this.state;
    if (prevState.expanded !== expanded) {
      this.props.onUpdate(expanded);
    }
  }

  componentWillUnmount() {
    this.pageWrapper && this.pageWrapper.classList.remove('has-item-tags');
  }

  /**
   * Toggle panel click event handler
   * */
  onToggleClick() {
    this.doToggle();
  }

  /**
   * Toggle panel key press event handler
   * @param {object} event The key press event object
   * */
  onToggleKeyPress(event) {
    /**
     * 13: Enter
     * 32: Space
     * */
    if ([13, 32].includes(event.which)) {
      event.preventDefault();
      this.doToggle();
    }
  }

  /**
   * Renders toggle button
   * @return <span>
   * */
  toggleButtonRender() {
    let label;
    let iconClassName;
    const { expanded } = this.state;

    if (expanded) {
      label = Toggle.LABELS.expanded;
      iconClassName = 'expanded';
    } else {
      label = Toggle.LABELS.collapsed;
      iconClassName = 'collapsed';
    }

    return (
      <span
        role="button"
        aria-label={label}
        tabIndex={0}
        onClick={this.onToggleClick}
        onKeyPress={this.onToggleKeyPress}
      >
        {<Icon size="12px" className={iconClassName} name="nav-arrow" />}
        {label}
      </span>
    );
  }

  /**
   * Do the toggle
   * */
  doToggle() {
    /**
     * Makes the reader ignore the changing of the label
     * */
    this.itemTagsToggle.setAttribute('aria-hidden', 'true');
    this.pageWrapper = isNil(this.pageWrapper)
      ? document.querySelector('.question-preview-player')
      : this.pageWrapper;
    this.setState((prevState) => {
      if (this.pageWrapper) {
        const expanded = !prevState.expanded;

        this.props.onChange(expanded);

        if (expanded) {
          this.pageWrapper.classList.add('has-item-tags');
        } else {
          this.pageWrapper.classList.remove('has-item-tags');
        }

        this.itemTagsToggle.removeAttribute('aria-hidden');
        return {
          expanded,
        };
      }
      throw new Error(
        `${this.displayName} + 'PageWrapper selector does not find element`,
      );
    });
  }

  render() {
    const { children } = this.props;
    const { expanded } = this.state;
    return (
      <div
        className={cn(
          `ItemMetadata__pane bg-blue-100 border-l border-gray-300 ${
            expanded ? 'expanded' : 'collapsed'
          }`,
        )}
      >
        <div className={cn('ItemMetadata__toggle_button bg-blue-100')}>
          {this.toggleButtonRender()}
        </div>
        {React.cloneElement(children, { expanded })}
      </div>
    );
  }
}

export default Toggle;
